import { server_connection } from 'config';
import { UPDATE_QUALIFICATION_FORM } from '../../../qualification/store/actions';
import store from 'store';

export const GET_INSTRUCTOR = '[INSTRUCTOR APP] GET INSTRUCTOR';
export const GET_INSTRUCTOR_LIST = '[INSTRUCTOR APP] GET INSTRUCTOR LIST';
export const DELETE_INSTRUCTOR = '[INSTRUCTOR APP] DELETE INSTRUCTOR';
export const UPDATE_INSTRUCTOR_LOADED = '[INSTRUCTOR APP] UPDATE INSTRUCTOR LOADED';
export const GET_RELATED_DATA = '[INSTRUCTOR APP] GET RELATED DATA';
export const SAVE_INSTRUCTOR = '[INSTRUCTOR APP] SAVE INSTRUCTOR';
export const UPDATE_INSTRUCTOR_FORM = '[INSTRUCTOR APP] UPDATE INSTRUCTOR FORM';
export const GET_INSTRUCTOR_QUALIFICATIONS = '[INSTRUCTOR APP] GET INSTRUCTOR QUALIFICATIONS';
export const GET_ALL_QUALIFICATIONS = '[INSTRUCTOR APP] GET ALL QUALIFICATIONS';
export const HANDLE_QUALIFICATION_SELECT = '[INSTUCTOR APP] HANDLE QUALIFICATION SELECT';
export const HANDLE_QUALIFICATION_TIME_CHANGE = '[INSTRUCTOR APP] HANDLE QUALIFICATION TIME CHANGE';
export const DELETE_QUALIFICATION = '[INSTRUCTOR APP] DELETE QUALIFICATION';
export const ACCEPT_QUALIFICATION = '[INSTRUCTOR APP] ACCEPT QUALIFICATION';
export const UPDATE_QUALIFICATION_ASSET = '[INSTRUCTOR APP] UPDATE_QUALIFICATION_ASSET';
export const ADMIN_ADD_QUALIFICATION = '[INSTRUCTOR APP] ADMIN ADD QUALIFICATION';
export const ADD_ASSET_TO_LIST = '[INSTRUCTOR APP] ADD ASSET TO LIST';
export const DROP_ASSET_FROM_LIST = '[INSTRUCTOR APP] DROP ASSET FROM LIST';
export const GET_DAY_UNSCHEDULED_EVENTS = '[INSTRUCTOR APP] GET TODAY UNSCHEDULED EVENTS';
export const GET_EVENTS_TO_GRADE = '[INSTRUCTOR APP] GET EVENTS TO GRADE';

// INSTRUCTOR -> Company relation
export const GET_ALL_COMPANIES = '[INSTRUCTOR APP] GET ALL COMPANIES';
export const TOGGLE_COMPANY = '[INSTRUCTOR APP] TOGGLE COMPANY';

export const GET_INSTRUCTOR_SCHEDULE = '[INSTRUCTOR APP] GET INSTRUCTOR SCHEDULE';
export const GET_DAY_EVENTS = '[INSTRUCTOR APP] GET DAY EVENTS';


export function updateInstructorLoaded(setting) {
    return {
        type: UPDATE_INSTRUCTOR_LOADED,
        payload: setting
    }
}

export function updateInstructorForm(instructor_data) {
    return {
        type: UPDATE_INSTRUCTOR_FORM,
        payload: instructor_data
    }
}

export function getInstructorData(instructor_id) {
    return (dispatch) => {
        Promise.all([
            dispatch(getInstructor(instructor_id)),
            dispatch(getAllCompanies()),
            dispatch(getRelatedData(instructor_id)),
            dispatch(getInstructorSchedule(instructor_id, new Date())),
            dispatch(getInstructorQualifications(instructor_id))
        ]).then(
            () => dispatch(updateInstructorLoaded(true))
        )
    }
}


export function getInstructor(instructor_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/instructor/get/' + instructor_id)
            .then((response) => response.json())
            .then((instructorData) => {
                dispatch({
                    type: GET_INSTRUCTOR,
                    payload: instructorData,
                });
            });
    }
}

export function deleteInstructor(instructor_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/instructor/delete',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ instructor_id: instructor_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: DELETE_INSTRUCTOR,
                    payload: instructor_id,
                });
            });
    }
}

export function saveInstructor(instructor, company_list, qualifications, auth_id) {
    const newInstructor = { ...instructor, CreateAuthID: auth_id, LastEditAuthID: auth_id }
    return async (dispatch, getState) => {
        await fetch(server_connection + '/instructor/save',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    instructor: newInstructor,
                    company_list: company_list,
                    qualifications: qualifications
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getInstructorList());
            });
    }
}

export function getRelatedData(instructor_id) {
    const auth_id = store.getState().auth.user.data.auth_id;
    return async (dispatch, getState) => {
        await fetch(server_connection + '/instructor/data/' + instructor_id + '/' + auth_id)
            .then((response) => response.json())
            .then((relatedData) => {
                dispatch({
                    type: GET_RELATED_DATA,
                    payload: relatedData
                })
            })
    }
}

export function getInstructorList() {
    return (dispatch, getState) => {
        fetch(server_connection + '/instructor/list')
            .then((response) => response.json())
            .then((instructorList) => {
                dispatch({
                    type: GET_INSTRUCTOR_LIST,
                    payload: instructorList,
                });
            });
    }
}

// INSTRUCTOR -> Company
function getAllCompanies() {
    return (dispatch) => {
        return fetch(server_connection + '/company/list')
            .then((response) => response.json())
            .then((allCompanies) => {
                return dispatch({
                    type: GET_ALL_COMPANIES,
                    payload: allCompanies
                })
            })
    }
}

export function toggleCompany(company, action_type) {
    return {
        type: TOGGLE_COMPANY,
        payload: { company: company, action_type: action_type }
    }
}

export function getInstructorSchedule(instructor_id, toggleDate) {
    const auth = store.getState().auth.user.data.auth_id;
    return async (dispatch) => {
        return await fetch(server_connection + '/instructor/schedule/' + instructor_id + '/' + toggleDate + '/' + auth)
            .then((response) => response.json())
            .then((events) => {
                dispatch({
                    type: GET_INSTRUCTOR_SCHEDULE,
                    payload: events
                })
            })
    }
}

export function getDayEvents(instructor_id, toggleDate) {
    const auth = store.getState().auth.user.data.auth_id;
    return async (dispatch) => {
        return await fetch(server_connection + '/instructor/schedule/day_events/' + instructor_id + '/' + toggleDate + '/' + auth)
            .then((response) => response.json())
            .then((events) => {
                dispatch({
                    type: GET_DAY_EVENTS,
                    payload: events
                })
            })
    }
}

export function getDayUnscheduledEvents(instructor_id, toggleDate) {
    const auth = store.getState().auth.user.data.auth_id;
    return async (dispatch) => {
        return await fetch(server_connection + '/instructor/test/day_events_unscheduled/' + instructor_id + '/' + toggleDate + '/' + auth)
            .then((response) => response.json())
            .then((events) => {
                dispatch({
                    type: GET_DAY_UNSCHEDULED_EVENTS,
                    payload: events
                })
            })
    }
}

export function getEventsToGrade(instructor_id) {
    return async (dispatch) => {
        return await fetch(server_connection + '/instructor/events_to_grade/' + instructor_id)
            .then((response) => response.json())
            .then((events) => {
                dispatch({
                    type: GET_EVENTS_TO_GRADE,
                    payload: events
                })
            })
    }
}

export function getInstructorQualifications(instructor_id) {
    return async (dispatch) => {
        return await fetch(server_connection + '/instructor/qualifications/' + instructor_id)
            .then((response) => response.json())
            .then((data) => {
                dispatch({
                    type: GET_INSTRUCTOR_QUALIFICATIONS,
                    payload: data
                })
            })
    }
}

export function getAllQualifications(companies, location) {
    return async (dispatch) => {
        return await fetch(server_connection + '/instructor/all_qualifications',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    companies,
                    location
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_ALL_QUALIFICATIONS,
                    payload: responseData
                });
            });
    }
}

export function handleQualificationSelect(qualification_id) {
    return {
        type: HANDLE_QUALIFICATION_SELECT,
        payload: qualification_id
    }
}

export function handleQualificationTimeChange(qual, value, column) {
    return {
        type: HANDLE_QUALIFICATION_TIME_CHANGE,
        payload: {
            qual, value, column
        }
    }
}

export function instructorQualificationApply(qualification, instructor_id, start, end, assets) {
    // const assets = asset ? asset.asset_id : null
    return async (dispatch, getState) => {
        await fetch(server_connection + '/instructor/qualification/apply',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    qualification: qualification,
                    instructor_id: instructor_id,
                    start: start,
                    end: end,
                    assets: assets
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getInstructorQualifications(instructor_id));
            });
    }
}


export function deleteQualification(qualification, instructor_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/instructor/qualification/delete',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    qualification: qualification
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getInstructorQualifications(instructor_id));
            });
    }
}

export function acceptQualification(qualification) {
    return {
        type: ACCEPT_QUALIFICATION,
        payload: qualification
    }
}

export function adminAddQualification(qualification, instructor_id, start, end, assets) {
    // return {
    //     type: ADMIN_ADD_QUALIFICATION,
    //     payload: { qualification, instructor_id, start, end, assets }
    // }
    return async (dispatch, getState) => {
        await fetch(server_connection + '/instructor/qualification/apply',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    qualification: qualification,
                    instructor_id: instructor_id,
                    start: start,
                    end: end,
                    assets: assets,
                    admin: true
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getInstructorQualifications(instructor_id));
            });
    }
}

// export function updateQualificationAsset(asset_id) {
//     return {
//         type: UPDATE_QUALIFICATION_ASSET,
//         payload: asset_id
//     }
// }

export function updateQualificationAsset(data) {
    // if (data === null) {
    return {
        type: UPDATE_QUALIFICATION_ASSET,
        payload: data
    }
    // }
    // return async (dispatch) => {
    //     return await fetch(server_connection + '/asset/' + asset_id)
    //         .then((response) => response.json())
    //         .then((data) => {
    //             dispatch({
    //                 type: UPDATE_QUALIFICATION_ASSET,
    //                 payload: data
    //             })
    //         })
    // }
}

export function addAssetToList(asset) {
    return {
        type: ADD_ASSET_TO_LIST,
        payload: asset
    }
}

export function dropAssetFromList(asset) {
    return {
        type: DROP_ASSET_FROM_LIST,
        payload: asset
    }
}

export function deactivateInstructorAuth(auth_id, instructor_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/auth/deactivate/' + auth_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(
                    {
                        type: DELETE_INSTRUCTOR,
                        payload: instructor_id
                    }
                )
            });
    }
}


// WEBPACK FOOTER //
// src/main/content/instructor/store/actions/instructor.actions.js